(function () {

/**
 * Console entry point.
 *
 * Runs only on pages the generator marked with `data-console-view`; every docs page skips
 * straight past it. The order matters: no view fetches anything until a session exists,
 * otherwise the first render is a wall of 401s.
 */ /**
 * Session handling, ported from the Nuxt console's AuthService.
 *
 * The platform keeps an httpOnly session cookie on the Livepush domain; this exchanges it
 * for a short-lived bearer token that every console request carries. The token lives in
 * localStorage so a reload does not need a round trip, and is dropped the moment the API
 * says it is stale.
 */ /** Build-time settings handed to the client through a JSON block in the page. */ let $afcceea26c0d199b$var$cached = null;
function $afcceea26c0d199b$export$6153d28e998a0254() {
    if ($afcceea26c0d199b$var$cached) return $afcceea26c0d199b$var$cached;
    const node = document.getElementById('console-config');
    if (!node?.textContent) throw new Error("console-config block missing \u2014 the page was not generated as a console page.");
    $afcceea26c0d199b$var$cached = JSON.parse(node.textContent);
    return $afcceea26c0d199b$var$cached;
}
function $afcceea26c0d199b$export$4cb887bfde2d34ca(path = '') {
    const base = $afcceea26c0d199b$export$6153d28e998a0254().basePath.replace(/\/+$/, '');
    const clean = path.replace(/^\/+|\/+$/g, '');
    return clean ? `${base}/${clean}/` : `${base}/`;
}


let $72521a20df509b40$var$inFlight = null;
function $72521a20df509b40$export$dd73543884f5db00() {
    try {
        return localStorage.getItem((0, $afcceea26c0d199b$export$6153d28e998a0254)().tokenKey);
    } catch  {
        return null;
    }
}
function $72521a20df509b40$var$storeToken(token) {
    try {
        localStorage.setItem((0, $afcceea26c0d199b$export$6153d28e998a0254)().tokenKey, token);
    } catch  {
    /* storage blocked — the token still works for this page view */ }
}
function $72521a20df509b40$export$4e887858c29ba818() {
    try {
        localStorage.removeItem((0, $afcceea26c0d199b$export$6153d28e998a0254)().tokenKey);
    } catch  {
    /* nothing to clear */ }
}
function $72521a20df509b40$export$c542b5e295206b2a() {
    if ($72521a20df509b40$var$inFlight) return $72521a20df509b40$var$inFlight;
    const { authApiBase: authApiBase } = (0, $afcceea26c0d199b$export$6153d28e998a0254)();
    $72521a20df509b40$var$inFlight = (async ()=>{
        try {
            const response = await fetch(`${authApiBase}/auth/access_token`, {
                credentials: 'include',
                headers: {
                    Accept: 'application/json'
                }
            });
            if (!response.ok) return null;
            const body = await response.json();
            if (!body.accessToken) return null;
            $72521a20df509b40$var$storeToken(body.accessToken);
            return body.accessToken;
        } catch  {
            return null;
        } finally{
            $72521a20df509b40$var$inFlight = null;
        }
    })();
    return $72521a20df509b40$var$inFlight;
}
function $72521a20df509b40$export$7c339088bccbf1e6(returnTo = window.location.href) {
    return `${(0, $afcceea26c0d199b$export$6153d28e998a0254)().loginUrl}?redirect=${encodeURIComponent(returnTo)}`;
}
function $72521a20df509b40$export$2fb87bbf5418dbe1() {
    window.location.href = $72521a20df509b40$export$7c339088bccbf1e6();
}
function $72521a20df509b40$export$b0ac3a1c242cb1ea() {
    $72521a20df509b40$export$4e887858c29ba818();
    const { logoutUrl: logoutUrl } = (0, $afcceea26c0d199b$export$6153d28e998a0254)();
    window.location.href = `${logoutUrl}?referer=${encodeURIComponent(window.location.href)}`;
}
async function $72521a20df509b40$export$f399813ec05a8bce() {
    const existing = $72521a20df509b40$export$dd73543884f5db00();
    if (existing) return existing;
    const fresh = await $72521a20df509b40$export$c542b5e295206b2a();
    if (fresh) return fresh;
    $72521a20df509b40$export$2fb87bbf5418dbe1();
    return null;
}


/**
 * The signed-in menu in the masthead, ported from the Nuxt Dropdown component.
 *
 * Only console pages render the mount point, so the docs pages never call the accounts
 * API or show a half-populated menu.
 */ /**
 * Accounts API client — the fetch equivalent of the Nuxt console's
 * DeveloperSettingsService and AccountService.
 *
 * Two differences from the original worth knowing about: the bearer token is read per
 * request rather than captured once at module load (the old client froze whatever token
 * existed when the bundle evaluated, so a refreshed token was ignored until reload), and a
 * 401 triggers a single token refresh and retry before giving up.
 */ 

class $0077aaebf07fc2f5$export$f2e832acab1bdd79 extends Error {
    status;
    constructor(status, message){
        super(message);
        this.name = 'ApiError';
        this.status = status;
    }
}
/** Longest error body worth showing verbatim. Anything larger is not a message. */ const $0077aaebf07fc2f5$var$MAX_ERROR_CHARS = 300;
/**
 * Turns a failed response into one short sentence.
 *
 * Never returns a raw body wholesale: when a request misses the API — a proxy answers, a
 * base URL is wrong, the dev server serves its own 404 page — the body is a full HTML
 * document, and dumping that into the UI is how a config mistake ends up looking like a
 * page of markup pasted under a form field.
 */ async function $0077aaebf07fc2f5$var$readError(response) {
    const fallback = `${response.statusText || 'Request failed'} (${response.status})`;
    try {
        const text = (await response.text()).trim();
        if (!text) return fallback;
        if (/^<(!doctype|html|\?xml)/i.test(text)) return fallback;
        try {
            const parsed = JSON.parse(text);
            const message = Array.isArray(parsed.message) ? parsed.message.join(', ') : parsed.message;
            const picked = message || parsed.error;
            return picked ? String(picked).slice(0, $0077aaebf07fc2f5$var$MAX_ERROR_CHARS) : fallback;
        } catch  {
            return text.length > $0077aaebf07fc2f5$var$MAX_ERROR_CHARS ? fallback : text;
        }
    } catch  {
        return fallback;
    }
}
async function $0077aaebf07fc2f5$var$request(path, options = {}) {
    const config = (0, $afcceea26c0d199b$export$6153d28e998a0254)();
    const service = options.service ?? 'accounts';
    const base = service === 'streams' ? config.streamsApiBase : config.accountsApiBase;
    const token = (0, $72521a20df509b40$export$dd73543884f5db00)();
    // Without this an absent base silently becomes a relative URL, and the request lands on
    // whatever is serving the page instead of the API. Fail where the mistake actually is.
    if (!base) throw new $0077aaebf07fc2f5$export$f2e832acab1bdd79(0, `No ${service} API base is configured. The page was built before this setting ` + "existed \u2014 restart the dev server, or rebuild the site.");
    const headers = {
        Accept: 'application/json'
    };
    if (token) headers.Authorization = `Bearer ${token}`;
    if (options.body !== undefined) headers['Content-Type'] = 'application/json';
    // Deliberately NOT `credentials: 'include'`: the bearer token is the only thing that
    // authenticates here, and asking for cookies would force credentialed CORS on every
    // accounts response. Only the token exchange in auth.ts needs the session cookie.
    const response = await fetch(`${base}${path}`, {
        method: options.method ?? 'GET',
        headers: headers,
        ...options.body === undefined ? {} : {
            body: JSON.stringify(options.body)
        }
    });
    if (response.status === 401 && !options.retry) {
        (0, $72521a20df509b40$export$4e887858c29ba818)();
        const fresh = await (0, $72521a20df509b40$export$c542b5e295206b2a)();
        if (fresh) return $0077aaebf07fc2f5$var$request(path, {
            ...options,
            retry: true
        });
        (0, $72521a20df509b40$export$2fb87bbf5418dbe1)();
        throw new $0077aaebf07fc2f5$export$f2e832acab1bdd79(401, "Your session has expired. Redirecting you to sign in\u2026");
    }
    if (!response.ok) throw new $0077aaebf07fc2f5$export$f2e832acab1bdd79(response.status, await $0077aaebf07fc2f5$var$readError(response));
    if (response.status === 204) return undefined;
    const text = await response.text();
    return text ? JSON.parse(text) : undefined;
}
const $0077aaebf07fc2f5$export$4f9234baf34abd0 = ()=>$0077aaebf07fc2f5$var$request('/account/this');
const $0077aaebf07fc2f5$export$33bb3fa8585ccba7 = ()=>$0077aaebf07fc2f5$var$request('/developer/apps');
const $0077aaebf07fc2f5$export$205bc258834dc08 = (appId)=>$0077aaebf07fc2f5$var$request(`/developer/apps/${encodeURIComponent(appId)}`);
const $0077aaebf07fc2f5$export$6e54c41955226d02 = (data)=>$0077aaebf07fc2f5$var$request('/developer/apps', {
        method: 'POST',
        body: data
    });
const $0077aaebf07fc2f5$export$df78b02a879196da = (appId, data)=>$0077aaebf07fc2f5$var$request(`/developer/apps/${encodeURIComponent(appId)}`, {
        method: 'PUT',
        body: data
    });
const $0077aaebf07fc2f5$export$10be5d8f29989531 = (appId)=>$0077aaebf07fc2f5$var$request(`/developer/apps/${encodeURIComponent(appId)}`, {
        method: 'DELETE'
    });
const $0077aaebf07fc2f5$export$933c3d4b0205df80 = (body)=>$0077aaebf07fc2f5$var$request('/images/upload_url', {
        method: 'POST',
        body: body,
        service: 'streams'
    });
const $0077aaebf07fc2f5$export$64205acd3650165c = (imageId)=>$0077aaebf07fc2f5$var$request(`/images/${encodeURIComponent(imageId)}`, {
        method: 'PUT',
        service: 'streams'
    });
const $0077aaebf07fc2f5$export$2d0b7dd5ef39c509 = (imageId)=>$0077aaebf07fc2f5$var$request(`/images/${encodeURIComponent(imageId)}`, {
        method: 'DELETE',
        service: 'streams'
    });
const $0077aaebf07fc2f5$export$82cac91dba22ebf = ()=>$0077aaebf07fc2f5$var$request('/developer/apps/suggestions');




/**
 * Small DOM helpers shared by the console views.
 *
 * Everything builds nodes through the DOM rather than innerHTML: app names, avatars and
 * redirect URIs are user-supplied, and Vue was escaping them for free before this port.
 */ function $ec325a230bf9bb9d$export$c3da0dad1b44eea9(tag, attrs = {}, children = []) {
    const node = document.createElement(tag);
    for (const [key, value] of Object.entries(attrs)){
        if (value === undefined || value === null || value === false) continue;
        if (key === 'class') node.className = String(value);
        else if (key === 'text') node.textContent = String(value);
        else if (value === true) node.setAttribute(key, '');
        else node.setAttribute(key, String(value));
    }
    for (const child of children){
        if (child === null || child === undefined) continue;
        node.append(typeof child === 'string' ? document.createTextNode(child) : child);
    }
    return node;
}
/** Inline SVG icons, kept as a map so views stay readable. */ const $ec325a230bf9bb9d$var$ICON_PATHS = {
    plus: 'M10 4.5v11M4.5 10h11',
    trash: 'M4 6h12M8.5 6V4.5h3V6M6 6l.8 10h6.4L14 6',
    copy: 'M7.5 7.5h8v8h-8zM12.5 7.5V4.5h-8v8h3',
    upload: 'M10 13.5v-9M6.5 8 10 4.5 13.5 8M4.5 13v2.5h11V13',
    external: 'M8 4.5H4.5v11h11V12M11 4.5h4.5V9M15.5 4.5 9 11'
};
function $ec325a230bf9bb9d$export$1ca1ec8b29a4ce27(name, size = 15) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('width', String(size));
    svg.setAttribute('height', String(size));
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', $ec325a230bf9bb9d$var$ICON_PATHS[name] ?? '');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.6');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.append(path);
    return svg;
}
function $ec325a230bf9bb9d$export$42ffd38884aecdac(node) {
    while(node.firstChild)node.firstChild.remove();
}
/* -------------------------------------------------------------------------- toasts */ let $ec325a230bf9bb9d$var$toastHost = null;
function $ec325a230bf9bb9d$export$b410431fab84fa58(message, tone = 'ok') {
    if (!$ec325a230bf9bb9d$var$toastHost) {
        $ec325a230bf9bb9d$var$toastHost = $ec325a230bf9bb9d$export$c3da0dad1b44eea9('div', {
            class: 'toast-host',
            role: 'status',
            'aria-live': 'polite'
        });
        document.body.append($ec325a230bf9bb9d$var$toastHost);
    }
    const node = $ec325a230bf9bb9d$export$c3da0dad1b44eea9('div', {
        class: `toast is-${tone}`,
        text: message
    });
    $ec325a230bf9bb9d$var$toastHost.append(node);
    window.setTimeout(()=>{
        node.classList.add('is-leaving');
        window.setTimeout(()=>node.remove(), 220);
    }, 4200);
}
function $ec325a230bf9bb9d$export$a7f6cffb6b8ba11c(options) {
    const opener = document.activeElement;
    const cancel = $ec325a230bf9bb9d$export$c3da0dad1b44eea9('button', {
        class: 'btn',
        type: 'button',
        text: options.cancelLabel ?? 'Cancel'
    });
    const confirm = $ec325a230bf9bb9d$export$c3da0dad1b44eea9('button', {
        class: `btn ${options.tone === 'danger' ? 'btn-danger-solid' : 'btn-primary'}`,
        type: 'button',
        text: options.confirmLabel
    });
    const dialog = $ec325a230bf9bb9d$export$c3da0dad1b44eea9('div', {
        class: 'modal',
        role: 'dialog',
        'aria-modal': 'true',
        'aria-labelledby': 'modal-title'
    }, [
        $ec325a230bf9bb9d$export$c3da0dad1b44eea9('div', {
            class: 'modal-head'
        }, [
            $ec325a230bf9bb9d$export$c3da0dad1b44eea9('h2', {
                id: 'modal-title',
                class: 'modal-title',
                text: options.title
            })
        ]),
        $ec325a230bf9bb9d$export$c3da0dad1b44eea9('div', {
            class: 'modal-body'
        }, [
            options.body
        ]),
        $ec325a230bf9bb9d$export$c3da0dad1b44eea9('div', {
            class: 'modal-foot'
        }, [
            cancel,
            confirm
        ])
    ]);
    const backdrop = $ec325a230bf9bb9d$export$c3da0dad1b44eea9('div', {
        class: 'modal-backdrop'
    }, [
        dialog
    ]);
    const close = ()=>{
        document.removeEventListener('keydown', onKey, true);
        backdrop.remove();
        document.body.classList.remove('modal-open');
        opener?.focus?.();
    };
    const onKey = (event)=>{
        if (event.key === 'Escape') {
            event.preventDefault();
            close();
            return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [
            ...dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        ].filter((node)=>!node.hasAttribute('disabled'));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    };
    cancel.addEventListener('click', close);
    backdrop.addEventListener('mousedown', (event)=>{
        if (event.target === backdrop) close();
    });
    document.addEventListener('keydown', onKey, true);
    confirm.addEventListener('click', async ()=>{
        confirm.disabled = true;
        confirm.classList.add('is-busy');
        try {
            const result = await options.onConfirm();
            if (result !== false) close();
        } finally{
            confirm.disabled = false;
            confirm.classList.remove('is-busy');
        }
    });
    document.body.classList.add('modal-open');
    document.body.append(backdrop);
    const firstField = dialog.querySelector('input, textarea, select');
    (firstField ?? confirm).focus();
    return close;
}
function $ec325a230bf9bb9d$export$8f50df58f957fd19(options) {
    $ec325a230bf9bb9d$export$a7f6cffb6b8ba11c({
        title: options.title,
        body: $ec325a230bf9bb9d$export$c3da0dad1b44eea9('p', {
            class: 'modal-text',
            text: options.message
        }),
        confirmLabel: options.confirmLabel,
        tone: 'danger',
        onConfirm: options.onConfirm
    });
}
function $ec325a230bf9bb9d$export$e0f35d825088c098(options) {
    const input = $ec325a230bf9bb9d$export$c3da0dad1b44eea9('input', {
        id: options.id,
        class: 'field',
        type: options.type ?? 'text',
        value: options.value ?? '',
        placeholder: options.placeholder,
        readonly: options.readonly,
        autocomplete: options.autocomplete ?? 'off',
        spellcheck: 'false'
    });
    // `value` as an attribute only seeds the default; set the property so later reads are right.
    input.value = options.value ?? '';
    const wrap = $ec325a230bf9bb9d$export$c3da0dad1b44eea9('div', {
        class: 'field-row'
    }, [
        $ec325a230bf9bb9d$export$c3da0dad1b44eea9('label', {
            class: 'field-label',
            for: options.id,
            text: options.label
        }),
        input,
        options.hint ? $ec325a230bf9bb9d$export$c3da0dad1b44eea9('p', {
            class: 'field-hint',
            text: options.hint
        }) : null
    ]);
    return {
        wrap: wrap,
        input: input
    };
}
function $ec325a230bf9bb9d$export$e3ad3b7f0452082b(wrap, buttons) {
    if (!buttons.length) return;
    wrap.classList.add('has-action');
    wrap.append($ec325a230bf9bb9d$export$c3da0dad1b44eea9('div', {
        class: 'field-actions'
    }, buttons));
}
function $ec325a230bf9bb9d$export$d3c9a1baf19ff79e(message, onRetry) {
    return $ec325a230bf9bb9d$export$c3da0dad1b44eea9('div', {
        class: 'console-empty is-error'
    }, [
        $ec325a230bf9bb9d$export$c3da0dad1b44eea9('p', {
            class: 'console-empty-title',
            text: 'Something went wrong'
        }),
        $ec325a230bf9bb9d$export$c3da0dad1b44eea9('p', {
            class: 'console-empty-note',
            text: message
        }),
        onRetry ? (()=>{
            const button = $ec325a230bf9bb9d$export$c3da0dad1b44eea9('button', {
                class: 'btn',
                type: 'button',
                text: 'Try again'
            });
            button.addEventListener('click', onRetry);
            return button;
        })() : null
    ]);
}


function $ef5e7e75da5174c7$var$displayName(account) {
    const full = [
        account.firstName,
        account.lastName
    ].filter(Boolean).join(' ').trim();
    return full || account.name || account.email || 'Account';
}
function $ef5e7e75da5174c7$var$initials(name) {
    const parts = name.split(/\s+/).filter(Boolean);
    const first = parts[0]?.charAt(0) ?? '?';
    const second = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (first + second).toUpperCase();
}
async function $ef5e7e75da5174c7$export$905a9912457199ee() {
    const host = document.querySelector('[data-console-account]');
    if (!host) return;
    let account;
    try {
        account = await (0, $0077aaebf07fc2f5$export$4f9234baf34abd0)();
    } catch  {
        // A failed lookup should not block the page — the views handle their own auth errors.
        return;
    }
    const { accountsAppBase: accountsAppBase, streamsAppBase: streamsAppBase } = (0, $afcceea26c0d199b$export$6153d28e998a0254)();
    const name = $ef5e7e75da5174c7$var$displayName(account);
    const avatar = account.avatar ? (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('img', {
        class: 'account-avatar',
        src: account.avatar,
        alt: '',
        decoding: 'async'
    }) : (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
        class: 'account-avatar is-placeholder',
        text: $ef5e7e75da5174c7$var$initials(name)
    });
    const trigger = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('button', {
        class: 'account-trigger',
        type: 'button',
        'aria-expanded': 'false',
        'aria-haspopup': 'menu',
        'aria-controls': 'account-menu'
    }, [
        avatar,
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
            class: 'account-name',
            text: name
        }),
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
            class: 'account-caret',
            'aria-hidden': 'true'
        })
    ]);
    const signout = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('button', {
        class: 'account-item is-signout',
        type: 'button',
        role: 'menuitem',
        text: 'Sign out'
    });
    signout.addEventListener('click', (0, $72521a20df509b40$export$b0ac3a1c242cb1ea));
    const menu = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
        class: 'account-menu',
        id: 'account-menu',
        role: 'menu',
        hidden: true
    }, [
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
            class: 'account-menu-head'
        }, [
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
                class: 'account-menu-name',
                text: name
            }),
            account.email ? (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
                class: 'account-menu-email',
                text: account.email
            }) : null
        ]),
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('a', {
            class: 'account-item',
            role: 'menuitem',
            href: `${streamsAppBase}/`,
            text: 'Dashboard'
        }),
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('a', {
            class: 'account-item',
            role: 'menuitem',
            href: `${accountsAppBase}/`,
            text: 'Account settings'
        }),
        signout
    ]);
    const setOpen = (open)=>{
        menu.hidden = !open;
        trigger.setAttribute('aria-expanded', String(open));
    };
    trigger.addEventListener('click', ()=>setOpen(menu.hidden));
    document.addEventListener('click', (event)=>{
        if (!host.contains(event.target)) setOpen(false);
    });
    document.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape') setOpen(false);
    });
    (0, $ec325a230bf9bb9d$export$42ffd38884aecdac)(host);
    host.append(trigger, menu);
    host.hidden = false;
}


/** App credentials — edit the display name and avatar, manage redirect URIs, delete. */ 


/**
 * Avatar uploads, on the streams-api image service.
 *
 * Follows what streams-app does for destination poster images (see its ImageService.js /
 * ImageUploadModal): sign, PUT the bytes straight to storage, mark the image uploaded. The
 * console never proxies the file, and nothing new had to be built server-side.
 *
 * Images are normalised to a square PNG before they leave the browser, so storage keeps one
 * predictable size and a 4MB phone photo does not become an app avatar.
 */ 
const $9f21e6f404d7d0e0$export$46b0ddb7f015c1ff = 5242880;
const $9f21e6f404d7d0e0$export$180e3fb924116a50 = 512;
const $9f21e6f404d7d0e0$export$5ae99ef87bff1ad = [
    'image/png',
    'image/jpeg',
    'image/webp',
    'image/gif'
];
const $9f21e6f404d7d0e0$export$feb42156344d1b92 = 'caption_img';
class $9f21e6f404d7d0e0$export$137ec66182ed30ea extends Error {
    constructor(message){
        super(message);
        this.name = 'UploadError';
    }
}
function $9f21e6f404d7d0e0$var$loadImage(file) {
    return new Promise((resolve, reject)=>{
        const objectUrl = URL.createObjectURL(file);
        const image = new Image();
        image.onload = ()=>{
            URL.revokeObjectURL(objectUrl);
            resolve(image);
        };
        image.onerror = ()=>{
            URL.revokeObjectURL(objectUrl);
            reject(new $9f21e6f404d7d0e0$export$137ec66182ed30ea('That file could not be read as an image.'));
        };
        image.src = objectUrl;
    });
}
async function $9f21e6f404d7d0e0$export$163a544b86d785fc(file) {
    if (!$9f21e6f404d7d0e0$export$5ae99ef87bff1ad.includes(file.type)) throw new $9f21e6f404d7d0e0$export$137ec66182ed30ea('Use a PNG, JPEG, WebP or GIF image.');
    if (file.size > $9f21e6f404d7d0e0$export$46b0ddb7f015c1ff) throw new $9f21e6f404d7d0e0$export$137ec66182ed30ea(`That image is ${(file.size / 1024 / 1024).toFixed(1)}MB. The limit is ` + `${$9f21e6f404d7d0e0$export$46b0ddb7f015c1ff / 1024 / 1024}MB.`);
    const image = await $9f21e6f404d7d0e0$var$loadImage(file);
    const source = Math.min(image.naturalWidth, image.naturalHeight);
    if (!source) throw new $9f21e6f404d7d0e0$export$137ec66182ed30ea('That image appears to be empty.');
    const edge = Math.min(source, $9f21e6f404d7d0e0$export$180e3fb924116a50);
    const canvas = document.createElement('canvas');
    canvas.width = edge;
    canvas.height = edge;
    const context = canvas.getContext('2d');
    if (!context) throw new $9f21e6f404d7d0e0$export$137ec66182ed30ea('This browser cannot process the image.');
    context.drawImage(image, (image.naturalWidth - source) / 2, (image.naturalHeight - source) / 2, source, source, 0, 0, edge, edge);
    const blob = await new Promise((resolve)=>canvas.toBlob(resolve, 'image/png'));
    if (!blob) throw new $9f21e6f404d7d0e0$export$137ec66182ed30ea('The image could not be processed.');
    return blob;
}
/**
 * PUTs the bytes to the signed URL. XHR rather than fetch purely for upload progress —
 * there is still no way to observe request progress with fetch. No Authorization header:
 * the signature is in the URL, and sending one breaks the storage request.
 */ function $9f21e6f404d7d0e0$var$putBytes(uploadUrl, blob, onProgress) {
    return new Promise((resolve, reject)=>{
        const request = new XMLHttpRequest();
        request.open('PUT', uploadUrl, true);
        request.setRequestHeader('Content-Type', 'image/png');
        request.upload.addEventListener('progress', (event)=>{
            if (event.lengthComputable) onProgress(event.loaded / event.total);
        });
        request.addEventListener('load', ()=>{
            if (request.status >= 200 && request.status < 300) resolve();
            else reject(new $9f21e6f404d7d0e0$export$137ec66182ed30ea(`Storage rejected the upload (${request.status}).`));
        });
        request.addEventListener('error', ()=>reject(new $9f21e6f404d7d0e0$export$137ec66182ed30ea('The upload failed. Check your connection and try again.')));
        request.addEventListener('abort', ()=>reject(new $9f21e6f404d7d0e0$export$137ec66182ed30ea('Upload cancelled.')));
        request.send(blob);
    });
}
async function $9f21e6f404d7d0e0$export$90653d7df52e8e82(imageId) {
    try {
        await (0, $0077aaebf07fc2f5$export$2d0b7dd5ef39c509)(imageId);
    } catch  {
    /* an orphaned image is not worth interrupting the person over */ }
}
const $9f21e6f404d7d0e0$export$4fc0c8789e4e6024 = (uploadUrl)=>uploadUrl.split('?')[0] ?? uploadUrl;
async function $9f21e6f404d7d0e0$export$db6dcff2e77846b2(file, onProgress = ()=>{}) {
    const blob = await $9f21e6f404d7d0e0$export$163a544b86d785fc(file);
    const target = await (0, $0077aaebf07fc2f5$export$933c3d4b0205df80)({
        assetType: $9f21e6f404d7d0e0$export$feb42156344d1b92,
        type: 'image/png',
        size: blob.size,
        originalFilename: file.name || 'avatar.png'
    });
    if (!target?.uploadUrl || !target?.uploadId) throw new $9f21e6f404d7d0e0$export$137ec66182ed30ea('The image service did not return an upload target.');
    onProgress(0);
    await $9f21e6f404d7d0e0$var$putBytes(target.uploadUrl, blob, onProgress);
    onProgress(1);
    // Commits the record. Skipping this leaves the image in limbo.
    await (0, $0077aaebf07fc2f5$export$64205acd3650165c)(target.uploadId);
    return {
        imageId: target.uploadId,
        url: $9f21e6f404d7d0e0$export$4fc0c8789e4e6024(target.uploadUrl)
    };
}


/** "My apps" — the list, the name/client-ID filter, and the create dialog. */ 


const $9c1194796a238e72$var$PREFILL_KEY = 'lp-console-app';
function $9c1194796a238e72$export$95a503d7a807acaa(app) {
    try {
        sessionStorage.setItem($9c1194796a238e72$var$PREFILL_KEY, JSON.stringify(app));
    } catch  {
    /* the detail page just fetches instead */ }
}
function $9c1194796a238e72$export$3d6fbed86e3ada1f(id) {
    try {
        const raw = sessionStorage.getItem($9c1194796a238e72$var$PREFILL_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed?.id === id ? parsed : null;
    } catch  {
        return null;
    }
}
const $9c1194796a238e72$var$detailUrl = (app)=>`${(0, $afcceea26c0d199b$export$4cb887bfde2d34ca)('apps/manage')}?id=${encodeURIComponent(app.id)}`;
function $9c1194796a238e72$var$appCard(app) {
    const avatar = app.avatar ? (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('img', {
        class: 'app-avatar',
        src: app.avatar,
        alt: '',
        loading: 'lazy',
        decoding: 'async'
    }) : (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
        class: 'app-avatar is-placeholder',
        'aria-hidden': 'true'
    }, [
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
            text: (app.name || '?').trim().charAt(0).toUpperCase()
        })
    ]);
    const manage = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('a', {
        class: 'btn btn-ghost',
        href: $9c1194796a238e72$var$detailUrl(app),
        text: 'Manage'
    });
    manage.addEventListener('click', ()=>$9c1194796a238e72$export$95a503d7a807acaa(app));
    return (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('article', {
        class: 'app-card'
    }, [
        avatar,
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
            class: 'app-card-main'
        }, [
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('h2', {
                class: 'app-card-name',
                text: app.name || 'Untitled app'
            }),
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
                class: 'app-card-id'
            }, [
                (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
                    class: 'app-card-id-label',
                    text: 'Client ID'
                }),
                (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('code', {
                    text: app.clientID ?? "\u2014"
                })
            ])
        ]),
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
            class: 'app-card-actions'
        }, [
            manage
        ])
    ]);
}
function $9c1194796a238e72$var$emptyState(onCreate) {
    const button = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('button', {
        class: 'btn btn-primary',
        type: 'button',
        text: 'Create your first app'
    });
    button.addEventListener('click', onCreate);
    return (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
        class: 'console-empty'
    }, [
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
            class: 'console-empty-title',
            text: 'No apps yet'
        }),
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
            class: 'console-empty-note',
            text: 'An app gives you a client ID and secret for authenticating against the Livepush API.'
        }),
        button
    ]);
}
function $9c1194796a238e72$var$noMatches(query) {
    return (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
        class: 'console-empty'
    }, [
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
            class: 'console-empty-title',
            text: 'No matching apps'
        }),
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
            class: 'console-empty-note',
            text: `Nothing matches \u{201C}${query}\u{201D}.`
        })
    ]);
}
async function $9c1194796a238e72$export$623faac1f48dca85(container) {
    const filterInput = document.querySelector('[data-app-filter]');
    const newButton = document.querySelector('[data-new-app]');
    let apps = [];
    let suggestedName = '';
    const render = ()=>{
        const query = (filterInput?.value ?? '').trim().toLowerCase();
        const visible = query ? apps.filter((app)=>app.name?.toLowerCase().includes(query) || app.clientID?.toLowerCase().includes(query)) : apps;
        (0, $ec325a230bf9bb9d$export$42ffd38884aecdac)(container);
        if (!apps.length) {
            container.append($9c1194796a238e72$var$emptyState(openCreate));
            return;
        }
        if (!visible.length) {
            container.append($9c1194796a238e72$var$noMatches(query));
            return;
        }
        const grid = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
            class: 'app-grid'
        }, visible.map($9c1194796a238e72$var$appCard));
        container.append(grid);
        container.append((0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
            class: 'console-count',
            text: visible.length === apps.length ? `${apps.length} app${apps.length === 1 ? '' : 's'}` : `${visible.length} of ${apps.length} apps`
        }));
    };
    function openCreate() {
        const name = (0, $ec325a230bf9bb9d$export$e0f35d825088c098)({
            label: 'App name',
            id: 'new-app-name',
            value: suggestedName,
            placeholder: 'My integration',
            hint: 'Shown on the OAuth consent screen. You can change it later.'
        });
        const error = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
            class: 'field-error',
            hidden: true
        });
        (0, $ec325a230bf9bb9d$export$a7f6cffb6b8ba11c)({
            title: 'Create a developer app',
            body: (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
                class: 'field-stack'
            }, [
                name.wrap,
                (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
                    class: 'field-hint',
                    text: 'You can upload an avatar once the app exists.'
                }),
                error
            ]),
            confirmLabel: 'Create app',
            onConfirm: async ()=>{
                const value = name.input.value.trim();
                if (!value) {
                    error.textContent = 'Give the app a name.';
                    error.hidden = false;
                    name.input.focus();
                    return false;
                }
                try {
                    const created = await (0, $0077aaebf07fc2f5$export$6e54c41955226d02)({
                        name: value
                    });
                    apps = [
                        ...apps,
                        created
                    ];
                    render();
                    (0, $ec325a230bf9bb9d$export$b410431fab84fa58)(`\u{201C}${created.name}\u{201D} created.`);
                    loadSuggestion();
                    return true;
                } catch (cause) {
                    error.textContent = cause instanceof (0, $0077aaebf07fc2f5$export$f2e832acab1bdd79) ? cause.message : 'Could not create the app. Try again.';
                    error.hidden = false;
                    return false;
                }
            }
        });
    }
    async function loadSuggestion() {
        try {
            const suggestion = await (0, $0077aaebf07fc2f5$export$82cac91dba22ebf)();
            suggestedName = suggestion?.name ?? '';
        } catch  {
            suggestedName = '';
        }
    }
    filterInput?.addEventListener('input', render);
    newButton?.addEventListener('click', openCreate);
    try {
        apps = await (0, $0077aaebf07fc2f5$export$33bb3fa8585ccba7)() ?? [];
    } catch (cause) {
        (0, $ec325a230bf9bb9d$export$42ffd38884aecdac)(container);
        container.append((0, $ec325a230bf9bb9d$export$d3c9a1baf19ff79e)(cause instanceof (0, $0077aaebf07fc2f5$export$f2e832acab1bdd79) ? cause.message : 'Could not load your apps.', ()=>window.location.reload()));
        return;
    }
    if (filterInput) filterInput.disabled = false;
    if (newButton) newButton.disabled = false;
    render();
    loadSuggestion();
}


const $b5e891015ebaf29c$var$SECRET_MASK = "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022";
function $b5e891015ebaf29c$var$copyButton(getValue, label) {
    const button = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('button', {
        class: 'field-action',
        type: 'button',
        'aria-label': `Copy ${label}`
    }, [
        (0, $ec325a230bf9bb9d$export$1ca1ec8b29a4ce27)('copy', 14),
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
            text: 'Copy'
        })
    ]);
    button.addEventListener('click', async ()=>{
        try {
            await navigator.clipboard.writeText(getValue());
            button.classList.add('is-done');
            const text = button.querySelector('span');
            if (text) text.textContent = 'Copied';
            window.setTimeout(()=>{
                button.classList.remove('is-done');
                if (text) text.textContent = 'Copy';
            }, 1600);
        } catch  {
            (0, $ec325a230bf9bb9d$export$b410431fab84fa58)('Could not copy to the clipboard.', 'error');
        }
    });
    return button;
}
function $b5e891015ebaf29c$var$redirectRow(value, onRemove) {
    const input = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('input', {
        class: 'field',
        type: 'url',
        placeholder: 'https://example.com/oauth/callback',
        spellcheck: 'false',
        'aria-label': 'Redirect URI'
    });
    input.value = value;
    const remove = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('button', {
        class: 'field-action is-danger',
        type: 'button',
        'aria-label': 'Remove this redirect URI'
    }, [
        (0, $ec325a230bf9bb9d$export$1ca1ec8b29a4ce27)('trash', 14),
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
            text: 'Remove'
        })
    ]);
    const row = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
        class: 'uri-row'
    }, [
        input,
        remove
    ]);
    remove.addEventListener('click', ()=>onRemove(row));
    return row;
}
async function $b5e891015ebaf29c$export$6e08820ebe1726f8(container) {
    const saveButton = document.querySelector('[data-save-app]');
    const deleteButton = document.querySelector('[data-delete-app]');
    const appId = new URLSearchParams(window.location.search).get('id');
    if (!appId) {
        (0, $ec325a230bf9bb9d$export$42ffd38884aecdac)(container);
        container.append((0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
            class: 'console-empty'
        }, [
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
                class: 'console-empty-title',
                text: 'No app selected'
            }),
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
                class: 'console-empty-note',
                text: 'Pick an app from the list to manage it.'
            }),
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('a', {
                class: 'btn btn-primary',
                href: (0, $afcceea26c0d199b$export$4cb887bfde2d34ca)('apps'),
                text: 'Back to my apps'
            })
        ]));
        return;
    }
    // The list page stashes the row it was showing, so the form paints immediately and the
    // fetch below only fills in the secret and redirect URIs.
    const cached = (0, $9c1194796a238e72$export$3d6fbed86e3ada1f)(appId);
    if (cached) render(cached);
    let fresh = null;
    try {
        fresh = await (0, $0077aaebf07fc2f5$export$205bc258834dc08)(appId);
    } catch (cause) {
        if (!cached) {
            (0, $ec325a230bf9bb9d$export$42ffd38884aecdac)(container);
            container.append((0, $ec325a230bf9bb9d$export$d3c9a1baf19ff79e)(cause instanceof (0, $0077aaebf07fc2f5$export$f2e832acab1bdd79) ? cause.message : 'Could not load this app.', ()=>window.location.reload()));
            return;
        }
        (0, $ec325a230bf9bb9d$export$b410431fab84fa58)("Showing the details we already had \u2014 refreshing failed.", 'error');
    }
    if (fresh) render(fresh);
    function render(data) {
        (0, $ec325a230bf9bb9d$export$42ffd38884aecdac)(container);
        const name = (0, $ec325a230bf9bb9d$export$e0f35d825088c098)({
            label: 'App display name',
            id: 'app-name',
            value: data.name ?? '',
            hint: 'Shown to users on the OAuth consent screen.'
        });
        const clientId = (0, $ec325a230bf9bb9d$export$e0f35d825088c098)({
            label: 'Client ID',
            id: 'app-client-id',
            value: data.clientID ?? '',
            readonly: true
        });
        (0, $ec325a230bf9bb9d$export$e3ad3b7f0452082b)(clientId.wrap, [
            $b5e891015ebaf29c$var$copyButton(()=>data.clientID ?? '', 'client ID')
        ]);
        const secret = (0, $ec325a230bf9bb9d$export$e0f35d825088c098)({
            label: 'Client secret',
            id: 'app-client-secret',
            value: data.clientSecret ? $b5e891015ebaf29c$var$SECRET_MASK : "\u2014",
            readonly: true,
            hint: 'Treat this like a password. Anyone holding it can act as your app.'
        });
        secret.input.classList.add('is-secret');
        let revealed = false;
        const reveal = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('button', {
            class: 'field-action',
            type: 'button',
            text: 'Show'
        });
        reveal.addEventListener('click', ()=>{
            revealed = !revealed;
            secret.input.value = revealed ? data.clientSecret ?? "\u2014" : $b5e891015ebaf29c$var$SECRET_MASK;
            reveal.textContent = revealed ? 'Hide' : 'Show';
        });
        if (data.clientSecret) (0, $ec325a230bf9bb9d$export$e3ad3b7f0452082b)(secret.wrap, [
            reveal,
            $b5e891015ebaf29c$var$copyButton(()=>data.clientSecret ?? '', 'client secret')
        ]);
        /* ------------------------------------------------------------- redirect URIs */ const uriList = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
            class: 'uri-list'
        });
        const removeRow = (row)=>{
            row.remove();
            if (!uriList.children.length) uriList.append(emptyUris());
            uriList.dispatchEvent(new Event('input'));
        };
        const emptyUris = ()=>(0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
                class: 'field-hint is-empty',
                text: 'No redirect URIs yet.'
            });
        const uris = data.redirectUris?.filter(Boolean) ?? [];
        if (uris.length) uris.forEach((uri)=>uriList.append($b5e891015ebaf29c$var$redirectRow(uri, removeRow)));
        else uriList.append(emptyUris());
        const addUri = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('button', {
            class: 'btn btn-ghost',
            type: 'button'
        }, [
            (0, $ec325a230bf9bb9d$export$1ca1ec8b29a4ce27)('plus', 14),
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
                text: 'Add redirect URI'
            })
        ]);
        addUri.addEventListener('click', ()=>{
            uriList.querySelector('.is-empty')?.remove();
            const row = $b5e891015ebaf29c$var$redirectRow('', removeRow);
            uriList.append(row);
            row.querySelector('input')?.focus();
            uriList.dispatchEvent(new Event('input'));
        });
        const uriSection = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('section', {
            class: 'console-section'
        }, [
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('h2', {
                class: 'console-section-title',
                text: 'OAuth redirect URIs'
            }),
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
                class: 'console-section-note',
                text: "A domain covers its subdomains. localhost and 127.0.0.1 are always allowed for local development."
            }),
            uriList,
            addUri
        ]);
        /* -------------------------------------------------------------------- avatar */ // What the API currently holds. The avatar writes as soon as it changes, so it needs
        // the *saved* name and URIs to send alongside — using the live inputs would quietly
        // persist half-finished edits to the other fields.
        let savedName = data.name ?? '';
        let savedUris = data.redirectUris?.filter(Boolean) ?? [];
        let avatarUrl = data.avatar ?? '';
        // Only set for an image uploaded during this visit. Replacing or removing one deletes
        // it again; an avatar saved in an earlier session has no id here, so it is left alone.
        let pendingImageId = '';
        const preview = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('img', {
            class: 'avatar-preview',
            src: avatarUrl,
            alt: 'App avatar preview'
        });
        const noAvatar = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
            class: 'avatar-empty',
            text: 'No avatar yet'
        });
        const showPreview = (hasImage)=>{
            preview.hidden = !hasImage;
            noAvatar.hidden = hasImage;
        };
        showPreview(Boolean(avatarUrl));
        preview.addEventListener('error', ()=>showPreview(false));
        const picker = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('input', {
            class: 'sr-only',
            type: 'file',
            accept: 'image/png,image/jpeg,image/webp,image/gif',
            id: 'app-avatar-file'
        });
        const uploadButton = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('button', {
            class: 'btn btn-ghost',
            type: 'button'
        }, [
            (0, $ec325a230bf9bb9d$export$1ca1ec8b29a4ce27)('upload', 14),
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
                text: avatarUrl ? 'Replace image' : 'Upload image'
            })
        ]);
        const removeButton = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('button', {
            class: 'btn btn-ghost',
            type: 'button',
            text: 'Remove'
        });
        removeButton.hidden = !avatarUrl;
        const progress = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
            class: 'upload-progress',
            hidden: true
        }, [
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
                class: 'upload-bar'
            })
        ]);
        const progressBar = progress.firstElementChild;
        const uploadNote = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
            class: 'field-hint',
            text: 'PNG, JPEG, WebP or GIF, up to 5MB. Cropped to a square.'
        });
        const dropzone = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
            class: 'avatar-frame is-dropzone',
            tabindex: '0',
            role: 'button'
        }, [
            preview,
            noAvatar,
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('span', {
                class: 'avatar-drop-hint',
                text: 'Drop image'
            })
        ]);
        /**
     * Writes just the avatar. The image is already committed server-side by the time this
     * runs, so leaving it dependent on a separate Save press only invites losing it.
     */ const persistAvatar = async (url)=>{
            try {
                await (0, $0077aaebf07fc2f5$export$df78b02a879196da)(data.id, {
                    name: savedName,
                    avatar: url,
                    redirectUris: savedUris
                });
                return true;
            } catch (cause) {
                (0, $ec325a230bf9bb9d$export$b410431fab84fa58)(cause instanceof (0, $0077aaebf07fc2f5$export$f2e832acab1bdd79) ? cause.message : 'Could not save the avatar.', 'error');
                return false;
            }
        };
        const setAvatar = (url, imageId = '')=>{
            if (pendingImageId && pendingImageId !== imageId) (0, $9f21e6f404d7d0e0$export$90653d7df52e8e82)(pendingImageId);
            pendingImageId = imageId;
            avatarUrl = url;
            preview.src = url;
            showPreview(Boolean(url));
            removeButton.hidden = !url;
            const label = uploadButton.querySelector('span');
            if (label) label.textContent = url ? 'Replace image' : 'Upload image';
        };
        const runUpload = async (file)=>{
            uploadNote.classList.remove('is-error');
            uploadButton.disabled = true;
            dropzone.classList.add('is-busy');
            progress.hidden = false;
            progressBar.style.width = '0%';
            try {
                const uploaded = await (0, $9f21e6f404d7d0e0$export$db6dcff2e77846b2)(file, (fraction)=>{
                    progressBar.style.width = `${Math.round(fraction * 100)}%`;
                });
                if (!await persistAvatar(uploaded.url)) {
                    // Nothing points at it now, so do not leave it behind in storage.
                    (0, $9f21e6f404d7d0e0$export$90653d7df52e8e82)(uploaded.imageId);
                    return;
                }
                setAvatar(uploaded.url, uploaded.imageId);
                (0, $ec325a230bf9bb9d$export$b410431fab84fa58)('Avatar updated.');
            } catch (cause) {
                const message = cause instanceof (0, $9f21e6f404d7d0e0$export$137ec66182ed30ea) || cause instanceof (0, $0077aaebf07fc2f5$export$f2e832acab1bdd79) ? cause.message : 'The upload failed.';
                uploadNote.textContent = message;
                uploadNote.classList.add('is-error');
                (0, $ec325a230bf9bb9d$export$b410431fab84fa58)(message, 'error');
            } finally{
                uploadButton.disabled = false;
                dropzone.classList.remove('is-busy');
                progress.hidden = true;
                picker.value = '';
            }
        };
        picker.addEventListener('change', ()=>{
            const file = picker.files?.[0];
            if (file) runUpload(file);
        });
        uploadButton.addEventListener('click', ()=>picker.click());
        dropzone.addEventListener('click', ()=>picker.click());
        dropzone.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                picker.click();
            }
        });
        for (const name of [
            'dragenter',
            'dragover'
        ])dropzone.addEventListener(name, (event)=>{
            event.preventDefault();
            dropzone.classList.add('is-over');
        });
        for (const name of [
            'dragleave',
            'dragend'
        ])dropzone.addEventListener(name, ()=>dropzone.classList.remove('is-over'));
        dropzone.addEventListener('drop', (event)=>{
            event.preventDefault();
            dropzone.classList.remove('is-over');
            const file = event.dataTransfer?.files?.[0];
            if (file) runUpload(file);
        });
        removeButton.addEventListener('click', async ()=>{
            removeButton.disabled = true;
            const removed = await persistAvatar('');
            removeButton.disabled = false;
            if (!removed) return;
            setAvatar('');
            (0, $ec325a230bf9bb9d$export$b410431fab84fa58)('Avatar removed.');
        });
        const aside = (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('aside', {
            class: 'console-aside'
        }, [
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('h2', {
                class: 'console-section-title',
                text: 'App avatar'
            }),
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
                class: 'console-section-note',
                text: 'Shown beside your app name on the OAuth consent screen. Saved as soon as you upload.'
            }),
            dropzone,
            progress,
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
                class: 'avatar-actions'
            }, [
                uploadButton,
                removeButton
            ]),
            uploadNote,
            picker
        ]);
        /* -------------------------------------------------------------------- layout */ container.append((0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
            class: 'console-columns'
        }, [
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
                class: 'console-column'
            }, [
                (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
                    class: 'field-stack'
                }, [
                    name.wrap,
                    clientId.wrap,
                    secret.wrap
                ]),
                uriSection
            ]),
            aside
        ]));
        /* ------------------------------------------------------------------- actions */ const collectUris = ()=>[
                ...uriList.querySelectorAll('input')
            ].map((input)=>input.value.trim()).filter(Boolean);
        const sameUris = (a, b)=>a.length === b.length && a.every((value, index)=>value === b[index]);
        /*
     * Save covers the name and the redirect URIs only — the avatar writes itself the moment
     * it is uploaded or removed, so it can never be a pending change.
     */ const isDirty = ()=>name.input.value.trim() !== savedName || !sameUris(collectUris(), savedUris);
        const refreshDirty = ()=>{
            if (saveButton) saveButton.disabled = !isDirty();
        };
        name.input.addEventListener('input', refreshDirty);
        uriList.addEventListener('input', refreshDirty);
        const save = async ()=>{
            const value = name.input.value.trim();
            if (!value) {
                name.input.focus();
                name.wrap.classList.add('has-error');
                (0, $ec325a230bf9bb9d$export$b410431fab84fa58)('The app needs a name.', 'error');
                return;
            }
            name.wrap.classList.remove('has-error');
            if (!saveButton) return;
            saveButton.disabled = true;
            const label = saveButton.textContent;
            saveButton.textContent = "Saving\u2026";
            try {
                const uris = collectUris();
                // The response is `{ success: true }`, not the app — track what was sent instead.
                await (0, $0077aaebf07fc2f5$export$df78b02a879196da)(data.id, {
                    name: value,
                    avatar: avatarUrl,
                    redirectUris: uris
                });
                savedName = value;
                savedUris = uris;
                data.name = value;
                data.avatar = avatarUrl;
                data.redirectUris = uris;
                // Saved, so it is no longer a throwaway upload to clean up.
                pendingImageId = '';
                (0, $ec325a230bf9bb9d$export$b410431fab84fa58)('Changes saved.');
            } catch (cause) {
                (0, $ec325a230bf9bb9d$export$b410431fab84fa58)(cause instanceof (0, $0077aaebf07fc2f5$export$f2e832acab1bdd79) ? cause.message : 'Could not save your changes.', 'error');
            } finally{
                saveButton.textContent = label ?? 'Save changes';
                refreshDirty();
            }
        };
        const remove = ()=>{
            (0, $ec325a230bf9bb9d$export$8f50df58f957fd19)({
                title: 'Delete this app?',
                message: `\u{201C}${data.name || 'This app'}\u{201D} will stop working immediately and its client ID and ` + 'secret are revoked. This cannot be undone.',
                confirmLabel: 'Delete app',
                onConfirm: async ()=>{
                    try {
                        await (0, $0077aaebf07fc2f5$export$10be5d8f29989531)(data.id);
                        window.location.href = (0, $afcceea26c0d199b$export$4cb887bfde2d34ca)('apps');
                    } catch (cause) {
                        (0, $ec325a230bf9bb9d$export$b410431fab84fa58)(cause instanceof (0, $0077aaebf07fc2f5$export$f2e832acab1bdd79) ? cause.message : 'Could not delete the app.', 'error');
                        return false;
                    }
                }
            });
        };
        if (saveButton) {
            saveButton.onclick = ()=>void save();
            refreshDirty();
        }
        if (deleteButton) {
            deleteButton.disabled = false;
            deleteButton.onclick = remove;
        }
        document.title = `${data.name || 'App credentials'} \u{2014} Livepush API`;
    }
}



/** Extensions — still a placeholder in the platform, so this stays a holding page. */ 

function $48eeabfe241e58d2$export$f169fbc5081c39e6(container) {
    (0, $ec325a230bf9bb9d$export$42ffd38884aecdac)(container);
    container.append((0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
        class: 'console-empty'
    }, [
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
            class: 'console-empty-title',
            text: 'Extensions are on the way'
        }),
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('p', {
            class: 'console-empty-note',
            text: "Extensions will let your app add surfaces inside the Livepush dashboard. Nothing to configure yet \u2014 build against the REST API in the meantime."
        }),
        (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('div', {
            class: 'hero-actions'
        }, [
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('a', {
                class: 'btn btn-primary',
                href: (0, $afcceea26c0d199b$export$4cb887bfde2d34ca)('apps'),
                text: 'Manage my apps'
            }),
            (0, $ec325a230bf9bb9d$export$c3da0dad1b44eea9)('a', {
                class: 'btn',
                href: `${(0, $afcceea26c0d199b$export$6153d28e998a0254)().docsBase}guides/getting-started/`,
                text: 'Read the API guide'
            })
        ])
    ]));
}


async function $bc370a16535007d6$export$9b08f263c0029e4d() {
    const container = document.querySelector('[data-console-view]');
    if (!container) return;
    const view = container.dataset.consoleView;
    // Extensions has nothing behind a login yet, so it renders without waiting on a token.
    if (view === 'extensions') {
        (0, $48eeabfe241e58d2$export$f169fbc5081c39e6)(container);
        (0, $ef5e7e75da5174c7$export$905a9912457199ee)();
        return;
    }
    const token = await (0, $72521a20df509b40$export$f399813ec05a8bce)();
    if (!token) return; // redirecting to sign in
    (0, $ef5e7e75da5174c7$export$905a9912457199ee)();
    try {
        if (view === 'apps') await (0, $9c1194796a238e72$export$623faac1f48dca85)(container);
        else if (view === 'app') await (0, $b5e891015ebaf29c$export$6e08820ebe1726f8)(container);
    } catch (cause) {
        // Anything the views did not already handle: leave a readable message rather than a
        // skeleton that never resolves.
        container.textContent = '';
        const message = document.createElement('p');
        message.className = 'console-empty-note';
        message.textContent = cause instanceof Error ? cause.message : 'The console failed to load. Reload the page.';
        container.append(message);
    }
}


function $634f5de6e550c204$export$2b364efbaa57f4ff() {
    document.addEventListener('click', (event)=>{
        const button = event.target?.closest('[data-copy]');
        if (!button) return;
        const explicit = button.dataset.copyText;
        const code = button.closest('[data-code]')?.querySelector('pre code');
        const text = explicit ?? code?.textContent ?? '';
        if (!text) return;
        navigator.clipboard.writeText(text).then(()=>{
            button.classList.add('is-done');
            setTimeout(()=>button.classList.remove('is-done'), 1600);
        }).catch(()=>{
        /* clipboard denied — leave the button unchanged rather than lying about success */ });
    });
}


/**
 * Intercom messenger.
 *
 * Mirrors the behaviour of livepush.io and the blog: any element carrying
 * `data-intercom-message` opens the messenger with that text pre-filled, falling back to
 * its href if the widget never loads. Page views are reported as `visited_page`.
 *
 * The widget is loaded lazily — on first interaction, or when the browser goes idle —
 * so it never competes with first paint on a docs page.
 */ /** Injected as <meta name="intercom-app-id"> from site.config.ts at build time. */ const $7c912f8c02d6b1a7$var$APP_ID = document.querySelector('meta[name="intercom-app-id"]')?.content ?? '';
let $7c912f8c02d6b1a7$var$loading = false;
function $7c912f8c02d6b1a7$var$loadWidget() {
    if ($7c912f8c02d6b1a7$var$loading || !$7c912f8c02d6b1a7$var$APP_ID) return;
    $7c912f8c02d6b1a7$var$loading = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://widget.intercom.io/widget/${$7c912f8c02d6b1a7$var$APP_ID}`;
    document.head.appendChild(script);
}
/** Stubs window.Intercom so calls made before the script lands are replayed after. */ function $7c912f8c02d6b1a7$var$installStub() {
    if (typeof window.Intercom === 'function') return;
    const queue = [];
    const stub = (...args)=>{
        queue.push(args);
    };
    stub.q = queue;
    stub.c = (args)=>queue.push(args);
    window.Intercom = stub;
}
function $7c912f8c02d6b1a7$var$openChat(message, fallbackUrl) {
    $7c912f8c02d6b1a7$var$loadWidget();
    let attempts = 0;
    const open = ()=>{
        // Once the real widget replaces the stub it exposes `booted`; until then, queue.
        if (typeof window.Intercom === 'function' && !window.Intercom.q) {
            window.Intercom(message ? 'showNewMessage' : 'show', ...message ? [
                message
            ] : []);
            return;
        }
        attempts += 1;
        if (attempts < 16) {
            setTimeout(open, 300);
            return;
        }
        if (fallbackUrl) window.location.href = fallbackUrl;
    };
    open();
}
function $7c912f8c02d6b1a7$export$a49f9937fd206a70() {
    if (!$7c912f8c02d6b1a7$var$APP_ID) return;
    window.intercomSettings = {
        api_base: 'https://api-iam.intercom.io',
        app_id: $7c912f8c02d6b1a7$var$APP_ID
    };
    $7c912f8c02d6b1a7$var$installStub();
    window.openChat = $7c912f8c02d6b1a7$var$openChat;
    document.addEventListener('click', (event)=>{
        const el = event.target?.closest('[data-intercom-message]');
        if (!el) return;
        event.preventDefault();
        $7c912f8c02d6b1a7$var$openChat(el.getAttribute('data-intercom-message') ?? undefined, el.getAttribute('href') ?? undefined);
    });
    const kick = ()=>{
        $7c912f8c02d6b1a7$var$loadWidget();
        window.Intercom?.('trackEvent', 'visited_page', {
            page: window.location.href
        });
    };
    const once = {
        once: true,
        passive: true
    };
    for (const evt of [
        'pointerdown',
        'keydown',
        'touchstart'
    ])window.addEventListener(evt, kick, once);
    if ('requestIdleCallback' in window) window.requestIdleCallback(kick, {
        timeout: 3500
    });
    else setTimeout(kick, 2500);
}


function $83053876cace0a5e$export$240cd81d1fa164a8() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const backdrop = document.querySelector('[data-menu-backdrop]');
    const setOpen = (open)=>{
        document.body.classList.toggle('nav-open', open);
        toggle?.setAttribute('aria-expanded', String(open));
        if (backdrop) backdrop.hidden = !open;
    };
    toggle?.addEventListener('click', ()=>setOpen(!document.body.classList.contains('nav-open')));
    backdrop?.addEventListener('click', ()=>setOpen(false));
    document.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape') setOpen(false);
    });
    $83053876cace0a5e$var$revealCurrentNavEntry();
}
/**
 * Scrolls the sidebar so the entry for the page you just opened is on screen.
 *
 * Every page marks its own entry with `aria-current="page"`, but not in the same place:
 * an operation page marks the `.nav-link`, while a tag page marks the anchor inside the
 * group heading. Matching on the attribute covers both, where matching on
 * `.nav-link.is-current` silently did nothing for tag pages.
 *
 * Measurement is done with rects rather than `offsetTop`, which is relative to the
 * nearest positioned ancestor and not necessarily the scroller.
 */ function $83053876cace0a5e$var$revealCurrentNavEntry() {
    const scroller = document.querySelector('[data-nav-scroll]');
    const current = scroller?.querySelector('[aria-current="page"]');
    if (!scroller || !current) return;
    const view = scroller.getBoundingClientRect();
    const target = current.getBoundingClientRect();
    // Already fully in view: leave the scroll position alone rather than jumping.
    if (target.top >= view.top && target.bottom <= view.bottom) return;
    const delta = target.top - view.top - (view.height - target.height) / 2;
    const max = scroller.scrollHeight - scroller.clientHeight;
    scroller.scrollTop = Math.min(Math.max(0, scroller.scrollTop + delta), max);
}
function $83053876cace0a5e$export$c5cbc9e0a188ee00() {
    const links = [
        ...document.querySelectorAll('.toc a')
    ];
    if (!links.length) return;
    const byId = new Map();
    const targets = [];
    for (const link of links){
        const id = decodeURIComponent(link.hash.slice(1));
        const target = id ? document.getElementById(id) : null;
        if (target) {
            byId.set(id, link);
            targets.push(target);
        }
    }
    if (!targets.length) return;
    const visible = new Set();
    const observer = new IntersectionObserver((entries)=>{
        for (const entry of entries)if (entry.isIntersecting) visible.add(entry.target.id);
        else visible.delete(entry.target.id);
        const firstVisible = targets.find((t)=>visible.has(t.id));
        for (const [id, link] of byId)link.classList.toggle('is-active', firstVisible?.id === id);
    }, {
        rootMargin: '-80px 0px -70% 0px',
        threshold: 0
    });
    targets.forEach((target)=>observer.observe(target));
}
function $83053876cace0a5e$export$faf8531163a886f6() {
    const slot = document.querySelector('[data-notfound-path]');
    if (slot) slot.textContent = window.location.pathname + window.location.search;
    const trigger = document.querySelector('[data-notfound-search]');
    trigger?.addEventListener('click', ()=>{
        const input = document.querySelector('[data-search-input]');
        if (!input) return;
        input.focus();
        input.select();
    });
}


let $9035d1aac7462696$var$index = null;
let $9035d1aac7462696$var$loading = null;
function $9035d1aac7462696$var$loadIndex() {
    if ($9035d1aac7462696$var$index) return Promise.resolve($9035d1aac7462696$var$index);
    $9035d1aac7462696$var$loading ??= fetch('/search-index.json').then((response)=>response.ok ? response.json() : []).then((data)=>{
        $9035d1aac7462696$var$index = data;
        return data;
    }).catch(()=>[]);
    return $9035d1aac7462696$var$loading;
}
function $9035d1aac7462696$var$score(record, query, terms) {
    const title = record.title.toLowerCase();
    const path = (record.path ?? '').toLowerCase();
    const body = record.body.toLowerCase();
    let total = 0;
    if (title === query) total += 120;
    if (title.startsWith(query)) total += 60;
    if (title.includes(query)) total += 40;
    if (path.includes(query)) total += 35;
    for (const term of terms){
        if (title.includes(term)) total += 14;
        if (path.includes(term)) total += 10;
        if (body.includes(term)) total += 4;
        if (record.section.toLowerCase().includes(term)) total += 3;
    }
    // Endpoint pages are usually what people are hunting for.
    if (record.kind === 'operation') total += 6;
    return total;
}
function $9035d1aac7462696$var$render(container, results, query) {
    if (!query) {
        container.hidden = true;
        container.innerHTML = '';
        return;
    }
    container.hidden = false;
    if (!results.length) {
        container.innerHTML = `<p class="search-empty">No matches for \u{201C}${$9035d1aac7462696$var$escapeHtml(query)}\u{201D}.</p>`;
        return;
    }
    container.innerHTML = results.map(({ record: record }, i)=>{
        const meta = record.method ? `${record.method} ${record.path ?? ''}` : record.section;
        return `<a class="search-result${i === 0 ? ' is-active' : ''}" href="${record.url}">
        <strong>${$9035d1aac7462696$var$escapeHtml(record.title)}</strong>
        <span>${$9035d1aac7462696$var$escapeHtml(meta)}</span>
      </a>`;
    }).join('');
}
function $9035d1aac7462696$var$escapeHtml(value) {
    return value.replace(/[&<>"']/g, (c)=>({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[c]);
}
function $9035d1aac7462696$export$942ff210707e0e16() {
    const form = document.querySelector('[data-search]');
    const input = document.querySelector('[data-search-input]');
    const results = document.querySelector('[data-search-results]');
    if (!form || !input || !results) return;
    let current = [];
    let activeIndex = 0;
    const run = async ()=>{
        const query = input.value.trim().toLowerCase();
        if (query.length < 2) {
            current = [];
            $9035d1aac7462696$var$render(results, current, '');
            return;
        }
        const records = await $9035d1aac7462696$var$loadIndex();
        const terms = query.split(/\s+/).filter(Boolean);
        current = records.map((record)=>({
                record: record,
                score: $9035d1aac7462696$var$score(record, query, terms)
            })).filter((entry)=>entry.score > 0).sort((a, b)=>b.score - a.score).slice(0, 8);
        activeIndex = 0;
        $9035d1aac7462696$var$render(results, current, query);
    };
    let timer;
    input.addEventListener('input', ()=>{
        window.clearTimeout(timer);
        timer = window.setTimeout(()=>void run(), 110);
    });
    input.addEventListener('focus', ()=>void $9035d1aac7462696$var$loadIndex());
    form.addEventListener('submit', (event)=>{
        event.preventDefault();
        const target = current[activeIndex]?.record.url;
        if (target) window.location.href = target;
    });
    input.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape') {
            input.value = '';
            $9035d1aac7462696$var$render(results, [], '');
            input.blur();
            return;
        }
        const delta = event.key === 'ArrowDown' ? 1 : event.key === 'ArrowUp' ? -1 : 0;
        if (!delta || !current.length) return;
        event.preventDefault();
        activeIndex = (activeIndex + delta + current.length) % current.length;
        const items = results.querySelectorAll('.search-result');
        items.forEach((item, i)=>item.classList.toggle('is-active', i === activeIndex));
        items[activeIndex]?.scrollIntoView({
            block: 'nearest'
        });
    });
    document.addEventListener('click', (event)=>{
        if (!form.contains(event.target) && !results.contains(event.target)) $9035d1aac7462696$var$render(results, [], '');
    });
    // "/" focuses search, the way most docs sites behave.
    document.addEventListener('keydown', (event)=>{
        const tag = event.target?.tagName;
        if (event.key === '/' && tag !== 'INPUT' && tag !== 'TEXTAREA') {
            event.preventDefault();
            input.focus();
            input.select();
        }
    });
    // Deep link support: /?q=streams pre-fills and runs the search.
    const initial = new URLSearchParams(window.location.search).get('q');
    if (initial) {
        input.value = initial;
        run();
    }
}


/**
 * Tab panels are all rendered visible in the HTML so crawlers index every response
 * shape and every code sample. This collapses them to real tabs once JS is running.
 */ function $99d0577126d33534$export$c92e8f569ad2976f() {
    for (const group of document.querySelectorAll('[data-tabs]')){
        const buttons = [
            ...group.querySelectorAll('.tab')
        ];
        const panels = [
            ...group.querySelectorAll('.tab-panel')
        ];
        if (buttons.length !== panels.length || !buttons.length) continue;
        // Windowed sample groups show the active language's filename on the right of the bar.
        const filenameEl = group.querySelector('.code-file');
        const select = (index, focus = false)=>{
            buttons.forEach((button, i)=>{
                const active = i === index;
                button.setAttribute('aria-selected', String(active));
                button.tabIndex = active ? 0 : -1;
                if (active && focus) button.focus();
            });
            panels.forEach((panel, i)=>{
                panel.hidden = i !== index;
            });
            const filename = buttons[index]?.dataset.filename;
            if (filenameEl && filename) filenameEl.textContent = filename;
        };
        const preferred = group.dataset.tabs === 'samples' ? $99d0577126d33534$var$readPreferredLanguage(buttons) : 0;
        select(preferred);
        buttons.forEach((button, index)=>{
            button.addEventListener('click', ()=>{
                select(index);
                if (group.dataset.tabs === 'samples') {
                    $99d0577126d33534$var$savePreferredLanguage(button.textContent?.trim() ?? '');
                    $99d0577126d33534$var$syncOtherSampleGroups(group, index);
                }
            });
            button.addEventListener('keydown', (event)=>{
                const delta = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
                if (!delta) return;
                event.preventDefault();
                select((index + delta + buttons.length) % buttons.length, true);
            });
        });
    }
}
const $99d0577126d33534$var$LANG_KEY = 'lp-docs-sample-language';
function $99d0577126d33534$var$readPreferredLanguage(buttons) {
    try {
        const stored = localStorage.getItem($99d0577126d33534$var$LANG_KEY);
        if (!stored) return 0;
        const index = buttons.findIndex((b)=>b.textContent?.trim() === stored);
        return index === -1 ? 0 : index;
    } catch  {
        return 0;
    }
}
function $99d0577126d33534$var$savePreferredLanguage(label) {
    try {
        localStorage.setItem($99d0577126d33534$var$LANG_KEY, label);
    } catch  {
    /* ignore */ }
}
function $99d0577126d33534$var$syncOtherSampleGroups(source, index) {
    for (const group of document.querySelectorAll('[data-tabs="samples"]')){
        if (group === source) continue;
        const button = group.querySelectorAll('.tab')[index];
        button?.click();
    }
}


const $ce6a60063274fef7$var$STORAGE_KEY = 'lp-docs-theme';
function $ce6a60063274fef7$export$4c47704ed26c13e8() {
    const toggle = document.querySelector('[data-theme-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', ()=>{
        const next = document.documentElement.dataset.theme === 'light' ? 'dark' : 'light';
        document.documentElement.dataset.theme = next;
        try {
            localStorage.setItem($ce6a60063274fef7$var$STORAGE_KEY, next);
        } catch  {
        /* storage blocked — the theme still applies for this page view */ }
    });
}


/** Mounts the Try it panel on any operation page that carries one. */ /**
 * The Try it panel: auth strip, request builder, safety gate, response viewer.
 *
 * Built with real DOM nodes rather than innerHTML, so no value a reader types or an API
 * returns is ever parsed as markup.
 */ /**
 * Token resolution for the Try it panel.
 *
 * Three ways in, tried in this order:
 *   1. A token already in localStorage, put there by the dashboard or by an earlier
 *      visit. Shared storage only works because the docs sit on the same origin family.
 *   2. The session cookie. The platform sets `srid` on the parent domain, so any
 *      *.livepush.io page can trade it for a bearer token at GET /auth/access_token.
 *      This is the path that makes "already signed in" work with no extra steps.
 *   3. A token the reader pastes in by hand, for anyone signed out or on another domain.
 *
 * Tokens are held in memory and in localStorage. They are never sent anywhere except the
 * API host the request targets, and never written to the console or the page URL.
 */ function $9099e9d4d11d9733$export$e1972d553866a803(token) {
    const part = token.split('.')[1];
    if (!part) return null;
    try {
        const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
        const payload = JSON.parse(json);
        const scope = payload.scope;
        const scopes = Array.isArray(scope) ? scope.map(String) : typeof scope === 'string' ? scope.split(/[,\s]+/).filter(Boolean) : [];
        return {
            name: payload.name,
            scopes: scopes
        };
    } catch  {
        return null;
    }
}
function $9099e9d4d11d9733$var$read(key) {
    try {
        return localStorage.getItem(key);
    } catch  {
        return null;
    }
}
function $9099e9d4d11d9733$var$write(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch  {
    /* private window or blocked storage — the token still works for this page view */ }
}
function $9099e9d4d11d9733$export$dd73543884f5db00(spec) {
    return $9099e9d4d11d9733$var$read(spec.auth.aliasKey) ?? $9099e9d4d11d9733$var$read(spec.auth.tokenKey);
}
function $9099e9d4d11d9733$export$fb36f315e946c7bb(spec, token) {
    $9099e9d4d11d9733$var$write(spec.auth.tokenKey, token);
}
function $9099e9d4d11d9733$export$3a9809ae0427bb6c(spec) {
    for (const key of [
        spec.auth.tokenKey,
        spec.auth.aliasKey
    ])try {
        localStorage.removeItem(key);
    } catch  {
    /* nothing to clear */ }
}
let $9099e9d4d11d9733$var$cookieExchange = null;
function $9099e9d4d11d9733$export$97276f392af4995f(spec) {
    if ($9099e9d4d11d9733$var$cookieExchange) return $9099e9d4d11d9733$var$cookieExchange;
    $9099e9d4d11d9733$var$cookieExchange = (async ()=>{
        try {
            const response = await fetch(`${spec.auth.authApiBase}/auth/access_token`, {
                credentials: 'include',
                headers: {
                    Accept: 'application/json'
                }
            });
            if (!response.ok) return null;
            const body = await response.json();
            if (!body.accessToken) return null;
            $9099e9d4d11d9733$export$fb36f315e946c7bb(spec, body.accessToken);
            return body.accessToken;
        } catch  {
            return null;
        } finally{
            $9099e9d4d11d9733$var$cookieExchange = null;
        }
    })();
    return $9099e9d4d11d9733$var$cookieExchange;
}
async function $9099e9d4d11d9733$export$1ad7999279473695(spec) {
    const existing = $9099e9d4d11d9733$export$dd73543884f5db00(spec);
    if (existing) return {
        token: existing,
        source: 'storage',
        resolved: true
    };
    const fresh = await $9099e9d4d11d9733$export$97276f392af4995f(spec);
    if (fresh) return {
        token: fresh,
        source: 'cookie',
        resolved: true
    };
    return {
        token: null,
        source: null,
        resolved: true
    };
}
function $9099e9d4d11d9733$export$62a0ebddfbca1332(spec) {
    return `${spec.auth.loginUrl}?redirect=${encodeURIComponent(window.location.href)}`;
}


/** Builds and sends the request the panel has been configured with. */ function $3f0f2dcbb724576a$var$include(param, values) {
    if (param.required) return true;
    if (!values.enabled[param.name]) return false;
    return (values.params[param.name] ?? '').trim() !== '';
}
function $3f0f2dcbb724576a$export$6c5295ef7e82f2b2(spec, values, token) {
    const missing = [];
    let path = spec.path;
    for (const param of spec.params.filter((p)=>p.in === 'path')){
        const value = (values.params[param.name] ?? '').trim();
        if (!value) missing.push(param.name);
        // encodeURIComponent, not raw: an id with a slash would otherwise rewrite the route.
        path = path.replace(`{${param.name}}`, encodeURIComponent(value));
    }
    const query = new URLSearchParams();
    for (const param of spec.params.filter((p)=>p.in === 'query')){
        if (!$3f0f2dcbb724576a$var$include(param, values)) {
            if (param.required) missing.push(param.name);
            continue;
        }
        const value = (values.params[param.name] ?? '').trim();
        if (param.required && !value) missing.push(param.name);
        query.set(param.name, value);
    }
    const headers = {
        Accept: 'application/json'
    };
    for (const param of spec.params.filter((p)=>p.in === 'header')){
        if (!$3f0f2dcbb724576a$var$include(param, values)) {
            if (param.required) missing.push(param.name);
            continue;
        }
        headers[param.name] = (values.params[param.name] ?? '').trim();
    }
    if (spec.requiresAuth && token) headers.Authorization = `Bearer ${token}`;
    let body;
    if (spec.body && values.body.trim()) {
        body = values.body;
        headers['Content-Type'] = spec.body.contentType;
    }
    const qs = query.toString();
    return {
        url: `${spec.server}${path}${qs ? `?${qs}` : ''}`,
        method: spec.method,
        headers: headers,
        body: body,
        missing: [
            ...new Set(missing)
        ]
    };
}
async function $3f0f2dcbb724576a$export$d5a1e65f8aa21b51(request) {
    const started = performance.now();
    try {
        const response = await fetch(request.url, {
            method: request.method,
            headers: request.headers,
            body: request.body,
            // No cookies: the bearer token is the only credential these hosts accept, and
            // asking for cookies would force credentialed CORS on every response.
            credentials: 'omit',
            mode: 'cors'
        });
        const text = await response.text();
        let json;
        try {
            json = text ? JSON.parse(text) : undefined;
        } catch  {
            json = undefined;
        }
        return {
            ok: response.ok,
            status: response.status,
            statusText: response.statusText,
            durationMs: Math.round(performance.now() - started),
            bytes: new Blob([
                text
            ]).size,
            headers: [
                ...response.headers.entries()
            ],
            text: text,
            json: json
        };
    } catch (error) {
        // fetch rejects for DNS, offline and CORS alike, and the browser deliberately hides
        // which. Say so plainly rather than guessing at a cause.
        return {
            ok: false,
            status: 0,
            statusText: 'Request failed',
            durationMs: Math.round(performance.now() - started),
            bytes: 0,
            headers: [],
            text: '',
            json: undefined,
            networkError: error instanceof Error && error.message ? error.message : 'The request did not complete.'
        };
    }
}
function $3f0f2dcbb724576a$export$ba4d210f29eaf9d7(request, tokenPlaceholder) {
    const lines = [
        `curl -X ${request.method} '${request.url}'`
    ];
    for (const [key, value] of Object.entries(request.headers)){
        const shown = key.toLowerCase() === 'authorization' ? `Bearer ${tokenPlaceholder}` : value;
        lines.push(`  -H '${key}: ${shown}'`);
    }
    if (request.body) lines.push(`  -d '${request.body.replace(/\n\s*/g, '')}'`);
    return lines.join(' \\\n');
}


const $2505ca83b7c280b1$var$GROUP_LABEL = {
    path: 'Path',
    query: 'Query',
    header: 'Header'
};
function $2505ca83b7c280b1$var$el(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
}
function $2505ca83b7c280b1$export$bed337c63526d7f2(root, spec) {
    const shell = root.querySelector('[data-tryit-shell]');
    const staticNote = root.querySelector('[data-tryit-static]');
    if (!shell) return;
    shell.textContent = '';
    shell.hidden = false;
    staticNote?.remove();
    const values = {
        params: Object.fromEntries(spec.params.map((p)=>[
                p.name,
                p.example ?? ''
            ])),
        enabled: Object.fromEntries(spec.params.map((p)=>[
                p.name,
                p.required
            ])),
        body: spec.body?.example ?? ''
    };
    let token = null;
    // ----------------------------------------------------------------- auth strip
    const auth = $2505ca83b7c280b1$var$el('div', 'tryit-auth');
    const authDot = $2505ca83b7c280b1$var$el('span', 'tryit-dot');
    authDot.setAttribute('aria-hidden', 'true');
    const authBody = $2505ca83b7c280b1$var$el('div', 'tryit-auth-body');
    const authState = $2505ca83b7c280b1$var$el('p', 'tryit-auth-state', "Checking for a signed-in session\u2026");
    const authScopes = $2505ca83b7c280b1$var$el('div', 'tryit-scopes');
    authBody.append(authState, authScopes);
    const authActions = $2505ca83b7c280b1$var$el('div', 'tryit-auth-actions');
    auth.append(authDot, authBody, authActions);
    const manual = $2505ca83b7c280b1$var$el('form', 'tryit-manual');
    manual.hidden = true;
    const manualInput = $2505ca83b7c280b1$var$el('input', 'tryit-input');
    manualInput.type = 'password';
    manualInput.placeholder = 'Paste a bearer token';
    manualInput.autocomplete = 'off';
    manualInput.spellcheck = false;
    const manualSave = $2505ca83b7c280b1$var$el('button', 'btn btn-sm', 'Use token');
    manualSave.type = 'submit';
    const manualHint = $2505ca83b7c280b1$var$el('p', 'tryit-hint', 'Open app.livepush.io while signed in, then run copy(localStorage.getItem("access_token")) in DevTools. Treat it like a password.');
    manual.append(manualInput, manualSave);
    /** Renders the granted scopes as chips, with `root` called out as full access. */ function renderScopes(scopes) {
        authScopes.textContent = '';
        if (!scopes.length) {
            authScopes.append($2505ca83b7c280b1$var$el('span', 'tryit-chip', 'scopes unknown'));
            return;
        }
        if (scopes.includes('root')) {
            // Worth shouting about: a root token bypasses every scope check, so the reader
            // is one Send away from doing anything their account can do.
            authScopes.append($2505ca83b7c280b1$var$el('span', 'tryit-chip is-warn', 'root'));
            authScopes.append($2505ca83b7c280b1$var$el('span', 'tryit-scope-note', 'full access to your account'));
            return;
        }
        // A long scope list would wrap the row into a block; show a few and keep the rest
        // on the title attribute.
        const shown = scopes.slice(0, 4);
        for (const scope of shown)authScopes.append($2505ca83b7c280b1$var$el('span', 'tryit-chip', scope));
        if (scopes.length > shown.length) {
            const more = $2505ca83b7c280b1$var$el('span', 'tryit-chip is-muted', `+${scopes.length - shown.length}`);
            more.title = scopes.slice(shown.length).join(', ');
            authScopes.append(more);
        }
    }
    function renderAuth() {
        authActions.textContent = '';
        auth.classList.remove('is-ready', 'is-checking');
        if (token) {
            const detail = (0, $9099e9d4d11d9733$export$e1972d553866a803)(token);
            auth.classList.add('is-ready');
            authState.textContent = detail?.name ? detail.name : 'Token ready';
            renderScopes(detail?.scopes ?? []);
            const signOut = $2505ca83b7c280b1$var$el('button', 'tryit-link', 'Switch token');
            signOut.type = 'button';
            signOut.addEventListener('click', ()=>{
                (0, $9099e9d4d11d9733$export$3a9809ae0427bb6c)(spec);
                token = null;
                manual.hidden = false;
                manualHint.hidden = false;
                renderAuth();
                update();
                manualInput.focus();
            });
            authActions.append(signOut);
            manual.hidden = true;
            manualHint.hidden = true;
            return;
        }
        authScopes.textContent = '';
        authState.textContent = 'Not signed in';
        const signIn = $2505ca83b7c280b1$var$el('a', 'btn btn-sm btn-primary', 'Sign in');
        signIn.href = (0, $9099e9d4d11d9733$export$62a0ebddfbca1332)(spec);
        const retry = $2505ca83b7c280b1$var$el('button', 'btn btn-sm btn-quiet', 'I signed in, re-check');
        retry.type = 'button';
        retry.addEventListener('click', ()=>void detectSession(true));
        const paste = $2505ca83b7c280b1$var$el('button', 'tryit-link', 'Paste a token');
        paste.type = 'button';
        paste.addEventListener('click', ()=>{
            manual.hidden = !manual.hidden;
            manualHint.hidden = manual.hidden;
            if (!manual.hidden) manualInput.focus();
        });
        authScopes.append($2505ca83b7c280b1$var$el('span', 'tryit-scope-note', 'Sign in to Livepush, or paste a token, to send requests.'));
        authActions.append(signIn, retry, paste);
    }
    manual.addEventListener('submit', (event)=>{
        event.preventDefault();
        const value = manualInput.value.trim();
        if (!value) return;
        token = value;
        (0, $9099e9d4d11d9733$export$fb36f315e946c7bb)(spec, value);
        manualInput.value = '';
        renderAuth();
        update();
    });
    async function detectSession(announce = false) {
        if (announce) {
            auth.classList.add('is-checking');
            authState.textContent = "Checking\u2026";
            authScopes.textContent = '';
        }
        const state = await (0, $9099e9d4d11d9733$export$1ad7999279473695)(spec);
        token = state.token;
        renderAuth();
        update();
    }
    // ------------------------------------------------------------------- builder
    const form = $2505ca83b7c280b1$var$el('form', 'tryit-form');
    form.noValidate = true;
    const fields = $2505ca83b7c280b1$var$el('div', 'tryit-fields');
    for (const group of [
        'path',
        'query',
        'header'
    ]){
        const inGroup = spec.params.filter((p)=>p.in === group);
        if (!inGroup.length) continue;
        const fieldset = $2505ca83b7c280b1$var$el('fieldset', 'tryit-group');
        const legend = $2505ca83b7c280b1$var$el('legend', 'tryit-legend', `${$2505ca83b7c280b1$var$GROUP_LABEL[group]} parameters`);
        fieldset.append(legend);
        for (const param of inGroup){
            const row = $2505ca83b7c280b1$var$el('div', 'tryit-row');
            const label = $2505ca83b7c280b1$var$el('label', 'tryit-label');
            label.htmlFor = `tryit-${spec.operationId}-${param.name}`;
            if (!param.required) {
                const toggle = $2505ca83b7c280b1$var$el('input', 'tryit-toggle');
                toggle.type = 'checkbox';
                toggle.checked = values.enabled[param.name] ?? false;
                toggle.addEventListener('change', ()=>{
                    values.enabled[param.name] = toggle.checked;
                    update();
                });
                label.append(toggle);
            }
            label.append($2505ca83b7c280b1$var$el('code', undefined, param.name));
            if (param.required) label.append($2505ca83b7c280b1$var$el('span', 'tryit-required', 'required'));
            row.append(label);
            let input;
            if (param.enum?.length) {
                const select = $2505ca83b7c280b1$var$el('select', 'tryit-input');
                for (const option of param.enum){
                    const node = $2505ca83b7c280b1$var$el('option', undefined, option);
                    node.value = option;
                    select.append(node);
                }
                select.value = values.params[param.name] ?? param.enum[0] ?? '';
                input = select;
            } else {
                const text = $2505ca83b7c280b1$var$el('input', 'tryit-input');
                text.type = 'text';
                text.value = values.params[param.name] ?? '';
                text.placeholder = param.example ?? param.type ?? 'value';
                text.autocomplete = 'off';
                text.spellcheck = false;
                input = text;
            }
            input.id = label.htmlFor;
            input.addEventListener('input', ()=>{
                values.params[param.name] = input.value;
                update();
            });
            input.addEventListener('change', ()=>{
                values.params[param.name] = input.value;
                update();
            });
            row.append(input);
            if (param.description) row.append($2505ca83b7c280b1$var$el('p', 'tryit-hint', param.description));
            fieldset.append(row);
        }
        fields.append(fieldset);
    }
    let bodyInput = null;
    if (spec.body) {
        const fieldset = $2505ca83b7c280b1$var$el('fieldset', 'tryit-group');
        fieldset.append($2505ca83b7c280b1$var$el('legend', 'tryit-legend', `Request body (${spec.body.contentType})`));
        const area = $2505ca83b7c280b1$var$el('textarea', 'tryit-input tryit-body');
        area.rows = Math.min(16, Math.max(4, spec.body.example.split('\n').length + 1));
        area.value = values.body;
        area.spellcheck = false;
        area.addEventListener('input', ()=>{
            values.body = area.value;
            update();
        });
        fieldset.append(area);
        const bodyError = $2505ca83b7c280b1$var$el('p', 'tryit-hint tryit-error');
        bodyError.hidden = true;
        fieldset.append(bodyError);
        bodyInput = area;
        area.addEventListener('blur', ()=>{
            if (!area.value.trim()) {
                bodyError.hidden = true;
                return;
            }
            try {
                JSON.parse(area.value);
                bodyError.hidden = true;
            } catch (error) {
                bodyError.hidden = false;
                bodyError.textContent = `Not valid JSON: ${error.message}`;
            }
        });
        fields.append(fieldset);
    }
    // --------------------------------------------------------------- preview + gate
    const preview = $2505ca83b7c280b1$var$el('pre', 'tryit-preview');
    const previewCode = $2505ca83b7c280b1$var$el('code');
    preview.append(previewCode);
    const gate = $2505ca83b7c280b1$var$el('div', 'tryit-gate');
    const gateNote = $2505ca83b7c280b1$var$el('p', 'tryit-gate-note');
    const gateConfirm = $2505ca83b7c280b1$var$el('input', 'tryit-input tryit-arm');
    gateConfirm.type = 'text';
    gateConfirm.autocomplete = 'off';
    gateConfirm.spellcheck = false;
    gate.append(gateNote);
    if (spec.risk === 'destructive') gate.append(gateConfirm);
    const actions = $2505ca83b7c280b1$var$el('div', 'tryit-actions');
    const send = $2505ca83b7c280b1$var$el('button', 'btn btn-primary', 'Send request');
    send.type = 'submit';
    const copy = $2505ca83b7c280b1$var$el('button', 'btn btn-quiet', 'Copy as curl');
    copy.type = 'button';
    const status = $2505ca83b7c280b1$var$el('p', 'tryit-status');
    actions.append(send, copy, status);
    // ------------------------------------------------------------------- response
    const result = $2505ca83b7c280b1$var$el('div', 'tryit-result');
    result.hidden = true;
    form.append(fields, gate, preview, actions);
    shell.append(auth, manual, manualHint, form, result);
    manualHint.hidden = true;
    /** The id a destructive call must have typed back to arm it. */ function armTarget() {
        const pathParams = spec.params.filter((p)=>p.in === 'path');
        const last = pathParams[pathParams.length - 1];
        return last ? (values.params[last.name] ?? '').trim() : '';
    }
    function update() {
        const request = (0, $3f0f2dcbb724576a$export$6c5295ef7e82f2b2)(spec, values, token);
        previewCode.textContent = `${request.method} ${request.url}`;
        const needsToken = spec.requiresAuth && !token;
        const armed = spec.risk !== 'destructive' || armTarget() !== '' && gateConfirm.value.trim() === armTarget();
        if (spec.risk === 'destructive') {
            const target = armTarget();
            gateConfirm.placeholder = target || 'the id above';
            gateNote.textContent = target ? `This permanently deletes data. Type ${target} to arm the request.` : 'This permanently deletes data. Fill in the path parameter above first.';
            gate.classList.add('is-destructive');
        } else if (spec.risk === 'mutating') {
            gateNote.textContent = 'This changes live data on your account.';
            gate.classList.add('is-mutating');
        } else gateNote.textContent = 'This only reads data.';
        send.disabled = needsToken || request.missing.length > 0 || !armed;
        status.textContent = needsToken ? 'Sign in or paste a token to send.' : request.missing.length ? `Fill in: ${request.missing.join(', ')}` : '';
    }
    gateConfirm.addEventListener('input', update);
    copy.addEventListener('click', async ()=>{
        const request = (0, $3f0f2dcbb724576a$export$6c5295ef7e82f2b2)(spec, values, token);
        try {
            await navigator.clipboard.writeText((0, $3f0f2dcbb724576a$export$ba4d210f29eaf9d7)(request, 'YOUR_API_TOKEN'));
            copy.textContent = 'Copied';
            setTimeout(()=>copy.textContent = 'Copy as curl', 1600);
        } catch  {
            status.textContent = 'Could not reach the clipboard.';
        }
    });
    form.addEventListener('submit', async (event)=>{
        event.preventDefault();
        if (send.disabled) return;
        if (spec.risk === 'mutating' && !window.confirm(`${spec.method} ${spec.path}\n\nThis changes live data on your account. Continue?`)) return;
        if (bodyInput && bodyInput.value.trim()) try {
            JSON.parse(bodyInput.value);
        } catch (error) {
            status.textContent = `Request body is not valid JSON: ${error.message}`;
            return;
        }
        send.disabled = true;
        send.textContent = "Sending\u2026";
        status.textContent = '';
        const request = (0, $3f0f2dcbb724576a$export$6c5295ef7e82f2b2)(spec, values, token);
        const response = await (0, $3f0f2dcbb724576a$export$d5a1e65f8aa21b51)(request);
        send.textContent = 'Send request';
        renderResult(response);
        update();
        // A 401 almost always means the stored token went stale; drop it so the next
        // attempt re-reads the cookie instead of failing the same way again.
        if (response.status === 401) {
            (0, $9099e9d4d11d9733$export$3a9809ae0427bb6c)(spec);
            token = null;
            renderAuth();
            update();
        }
    });
    function renderResult(response) {
        result.hidden = false;
        result.textContent = '';
        const head = $2505ca83b7c280b1$var$el('div', 'tryit-result-head');
        const code = $2505ca83b7c280b1$var$el('span', `tryit-code ${response.ok ? 'is-ok' : response.status === 0 ? 'is-fail' : 'is-error'}`, response.status === 0 ? 'failed' : `${response.status} ${response.statusText}`);
        head.append(code, $2505ca83b7c280b1$var$el('span', 'tryit-meta', `${response.durationMs} ms \xb7 ${response.bytes} B`));
        result.append(head);
        if (response.networkError) {
            const note = $2505ca83b7c280b1$var$el('p', 'callout is-warning');
            note.textContent = "The request never reached the server. The usual cause is that this docs origin is not yet in the API host\u2019s CORS allowlist; being offline or blocking the request in an extension looks identical to the browser. The curl above will work regardless.";
            result.append(note);
            return;
        }
        const bodyPre = $2505ca83b7c280b1$var$el('pre', 'tryit-response');
        const bodyCode = $2505ca83b7c280b1$var$el('code');
        bodyCode.textContent = response.json !== undefined ? JSON.stringify(response.json, null, 2) : response.text || '(empty body)';
        bodyPre.append(bodyCode);
        result.append(bodyPre);
        if (response.headers.length) {
            const details = $2505ca83b7c280b1$var$el('details', 'tryit-headers');
            details.append($2505ca83b7c280b1$var$el('summary', undefined, `Response headers (${response.headers.length})`));
            const list = $2505ca83b7c280b1$var$el('pre');
            list.textContent = response.headers.map(([k, v])=>`${k}: ${v}`).join('\n');
            details.append(list);
            result.append(details);
        }
    }
    renderAuth();
    update();
    detectSession();
}


/** The shape the page hands the client. Mirrors scripts/templates/tryit.ts. */ function $95bfd67d9b9d8128$export$1b8bcac9b77e8a28(root) {
    const node = root.querySelector('.tryit-spec');
    if (!node?.textContent) return null;
    try {
        return JSON.parse(node.textContent);
    } catch  {
        return null;
    }
}


function $c7c09aeeb1f967bb$export$11426e27ad8b81e2() {
    const roots = [
        ...document.querySelectorAll('[data-tryit]')
    ];
    if (!roots.length) return;
    const mount = (root)=>{
        if (root.dataset.tryitMounted) return;
        root.dataset.tryitMounted = 'true';
        const spec = (0, $95bfd67d9b9d8128$export$1b8bcac9b77e8a28)(root);
        if (!spec) return;
        try {
            (0, $2505ca83b7c280b1$export$bed337c63526d7f2)(root, spec);
        } catch (error) {
            // A broken panel must not take the rest of the page's JavaScript with it; the
            // static summary stays on screen as the fallback.
            console.error('Try it panel failed to mount', error);
        }
    };
    if (!('IntersectionObserver' in window)) {
        roots.forEach(mount);
        return;
    }
    const observer = new IntersectionObserver((entries)=>{
        for (const entry of entries){
            if (!entry.isIntersecting) continue;
            observer.unobserve(entry.target);
            mount(entry.target);
        }
    }, {
        rootMargin: '400px 0px'
    });
    for (const root of roots)observer.observe(root);
}


// Marks the document as JS-capable so CSS can hide inactive tab panels. Until this
// runs, every panel is visible — which is exactly what a crawler should see.
document.documentElement.classList.add('js');
(0, $ce6a60063274fef7$export$4c47704ed26c13e8)();
(0, $83053876cace0a5e$export$240cd81d1fa164a8)();
(0, $99d0577126d33534$export$c92e8f569ad2976f)();
(0, $634f5de6e550c204$export$2b364efbaa57f4ff)();
(0, $9035d1aac7462696$export$942ff210707e0e16)();
(0, $83053876cace0a5e$export$c5cbc9e0a188ee00)();
(0, $7c912f8c02d6b1a7$export$a49f9937fd206a70)();
(0, $c7c09aeeb1f967bb$export$11426e27ad8b81e2)();
(0, $83053876cace0a5e$export$faf8531163a886f6)();
// Console pages carry a mount point; every documentation page skips this entirely.
if (document.querySelector('[data-console-view]')) (0, $bc370a16535007d6$export$9b08f263c0029e4d)();

})();
//# sourceMappingURL=index.js.map
